module.exports = __webpack_public_path__ + "dff0534760a37ece2e40f5b8b3779310.pdf";